import axios from 'axios';
import Notifications from './Notifications.vue';

const defaultSuccessTimeout = 1360;

export default function install(Vue) {
  let instance = null;

  /**
   * Opens a neat little notification popup in the bottom right corner.
   * Calling $notify(options) will attach an instance to the body if it didn't exist before.
   *
   * @param params
   */
  function notify(params) {
    if (!instance) {
      instance = new Vue(Notifications).$mount();
      document.querySelector('body').appendChild(instance.$el);
    }

    return instance.display(params);
  }

  function wrapNotifyAsync(
    async, display, success = null,
    idle = null, done = null, error = null,
  ) {
    // Build notification
    const notification = notify({
      text: idle || `<strong>${display}</strong> wird gespeichert&hellip;`,
      timeout: 0,
    });

    // Send off to server
    return async.then((response) => {
      // Success callback
      if (success) {
        success(response);
      }

      notification.text = done || `<strong>${display}</strong> wurde gespeichert`;
      notification.type = 'success';

      setTimeout(() => {
        notification.close = true;
      }, defaultSuccessTimeout);
    }).catch((exception) => {
      let { response, message } = exception;

      // Propagate error if it's not from axios, but our success call
      if (message === undefined || response === undefined) throw exception;

      // Handle server side validation errors
      if (response.status === 422) {
        message = '<ul class="list-unstyled no-margin"><li>';
        message += Object.values(response.data.errors).join('</li><li>');
        message += '</li></ul>';

        response = null;
      }

      const text = response ? `${response.status}: ${response.statusText}` : message;

      notification.text = `${error || `<strong>Fehler beim Speichern von ${display}</strong>`}:<br> ${text}`;
      notification.type = 'danger';
    });
  }

  /**
   * Notification helper for asynchronous tasks (hardwired to a PUT request right now).
   *
   * @param url
   * @param key
   * @param val
   * @param old
   * @param display
   * @param success
   */
  function notifyAsync(url, key, val, old, display, success, protocol = 'put') {
    wrapNotifyAsync(
      axios[protocol](typeof url === 'string' ? url : url.apply(this, [key]), { [key]: val }),
      display,
      success ? () => success.apply(this, [val, old]) : undefined,
    );
  }

  // Assignments
  Vue.notify = notify;
  Vue.notifyAsync = notifyAsync;
  Vue.wrapNotifyAsync = wrapNotifyAsync;

  Vue.prototype.$notify = notify;
  Vue.prototype.$notifyAsync = notifyAsync;
  Vue.prototype.$wrapNotifyAsync = wrapNotifyAsync;
}



// WEBPACK FOOTER //
// ./resources/assets/js/notifications/index.js